import React from "react";

import { Helpers } from "../config/Helpers"
import {ReactSession} from "react-client-session";
import {toast} from "react-toastify";
import queryString from "query-string";
import {decode as base64_decode, encode as base64_encode} from "base-64";
import {Modal, ModalBody} from "reactstrap";

class Login extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            urlParam: queryString.parse(window.location.search),
            email: '',
            password: '',
            emailForgot: '',
            isModalOpen: this.props.modalRef,
            securePassword: true,
        }
    }

    componentDidMount() {
        if(this.state.sessUserCode){
            window.location.href = './';
        }
    }

    handleModal = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    securePassword = () => {
        this.setState({ securePassword: !this.state.securePassword });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        Helpers.getLoginData(this.state.email, this.state.password, '',ReactSession.get("sess_email")).then(res => {
            if(res.length > 0){
                const r = res[0];

                ReactSession.set("sess_userid", r.UserId);
                ReactSession.set("sess_fullname", r.UserFullName);
                ReactSession.set("sess_branchcode", r.BranchCode);
                ReactSession.set("sess_employeecode", r.EmployeeCode);
                ReactSession.set("sess_profileid", r.UserProfileId);
                ReactSession.set("sess_email", r.Email);
                ReactSession.set("sess_usercode", r.KodeUser);
                ReactSession.set("sess_usertype", r.UserType);
                ReactSession.set("sess_uuid", r.UUID);
                ReactSession.set("sess_password", this.state.password);

                this.setState({
                    email: '',
                    password: ''
                });

                const parUrl = (this.state.urlParam.redirectUrl) ? base64_decode(this.state.urlParam.redirectUrl) : '';
                if(this.state.urlParam.voucher){
                    window.location.href = '/?voucher='+this.state.urlParam.voucher;
                }else{
                    window.location.href = parUrl;
                }
            }else{
                toast.error(Helpers.MSG_ERROR_LOGIN);
            }
        })
    };

    handleResetPassword = () => {
        Helpers.forgotPassword(this.state.emailForgot).then(res => {
            if(res.length > 0){
                const r = res[0];

                if(r.alert == 'success'){
                    this.setState({
                        emailForgot: ''
                    });

                    this.handleModal();
                }

                toast[r.alert](r.message);
            }else{
                toast.error(Helpers.MSG_ERROR_LOGIN);
            }
        })
    };

    render() {
        return (
            <>
                <Modal
                    size={'md'}
                    isOpen={this.state.isModalOpen}
                    toggle={() => {this.handleModal()}}
                    contentClassName="modal-picker-content">
                    <ModalBody className="modal-picker-body">
                        <div className="modal-picker-header">
                            <div className="modal-picker-title">
                                <span className="modal-picker-icon"><i className="fi-rs-lock"></i></span>
                                Lupa Password
                            </div>
                            <button type="button" className="modal-picker-close" onClick={() => {this.handleModal()}} aria-label="Tutup">
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>

                        <div className="auth-card-body" style={{'padding': '20px'}}>
                            <p className="auth-subtitle mb-15">Masukkan email akun kamu, kami akan mengirimkan link untuk reset password.</p>
                            <div className="auth-input-group mb-20">
                                <i className="fi-rs-envelope auth-input-icon"></i>
                                <input value={this.state.emailForgot} onChange={e => this.setState({emailForgot: e.target.value})}
                                       placeholder="Masukkan Email"
                                       type={'email'} required/>
                            </div>
                            <button type="button" className="auth-btn-primary" onClick={() => {this.handleResetPassword()}}>
                                Reset Password
                            </button>
                        </div>
                    </ModalBody>
                </Modal>

                <main className="main pages auth-page-wrap">
                    <div className="auth-wrap">
                        <div className="auth-hero">
                            <div className="auth-hero-icon">
                                <i className="fi-rs-user"></i>
                            </div>
                            <h1 className="auth-hero-title">Selamat Datang Kembali!</h1>
                            <p className="auth-hero-subtitle">Masuk untuk lanjut belanja hemat di Waroq</p>
                        </div>

                        <div className="auth-card">
                            <form method="post" onSubmit={(e) => {this.handleSubmit(e)}}>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-user auth-input-icon"></i>
                                    <input required type="text" value={this.state.email} onChange={e => this.setState({email: e.target.value})}
                                           placeholder="Email/No Telepon/Kode Warung"/>
                                </div>
                                <div className="auth-input-group mb-10">
                                    <i className="fi-rs-lock auth-input-icon"></i>
                                    <input required type={this.state.securePassword ? 'password' : 'text'} value={this.state.password} onChange={e => this.setState({password: e.target.value})}
                                           placeholder="Password"/>
                                    <i className={'fi-rs-' + (this.state.securePassword ? 'eye' : 'eye-crossed') + ' auth-input-icon-right'} onClick={() => {this.securePassword()}}></i>
                                </div>

                                <div className="auth-forgot-wrap">
                                    <a className="auth-link" href="javascript:void(0);" onClick={() => {this.handleModal()}}>Lupa Password?</a>
                                </div>

                                <button type="submit" className="auth-btn-primary" name="login">Masuk</button>

                                <div className="auth-divider">
                                    <span></span>
                                    <p>atau daftar baru</p>
                                    <span></span>
                                </div>

                                <a href={(this.state.urlParam.voucher) ? './register?voucher='+this.state.urlParam.voucher : './register'} className="auth-btn-outline">
                                    Daftar
                                </a>
                            </form>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default Login;
